export const jsFunctions: JsFunction[] = [
  {
    label: "at",
    documentation:
      "Returns the element at the given index. Negative values count back from the last element.",
    detail: "at(index: number): number",
    insertText: "at(${1:index})",
  },
  {
    label: "charAt",

    documentation: "Returns the character at the specified index.",
    detail: "charAt(index: number): string",
    insertText: "charAt(${1:index})",
  },
  {
    label: "charCodeAt",

    documentation: "Returns the Unicode of the character at the specified index.",
    detail: "charCodeAt(index: number): number",
    insertText: "charCodeAt(${1:index})",
  },
  {
    label: "codePointAt",

    documentation: "Returns a non-negative integer that is the Unicode code point value.",
    detail: "codePointAt(pos: number): number | undefined",
    insertText: "codePointAt(${1:pos})",
  },
  {
    label: "endsWith",

    documentation: "Determines whether a string ends with the characters of a specified string.",
    detail: "endsWith(searchString: string, endPosition?: number): boolean",
    insertText: "endsWith(${1:searchString}, ${2:endPosition})",
  },
  {
    label: "includes",

    documentation: "Determines whether a string contains the characters of a specified string.",
    detail: "includes(searchString: string, position?: number): boolean",
    insertText: "includes(${1:searchString}, ${2:position})",
  },
  {
    label: "indexOf",

    documentation: "Returns the index of the first occurrence of a specified value.",
    detail: "indexOf(searchValue: string, fromIndex?: number): number",
    insertText: "indexOf(${1:searchValue}, ${2:fromIndex})",
  },
  {
    label: "lastIndexOf",

    documentation: "Returns the index of the last occurrence of a specified value.",
    detail: "lastIndexOf(searchValue: string, fromIndex?: number): number",
    insertText: "lastIndexOf(${1:searchValue}, ${2:fromIndex})",
  },
  {
    label: "localeCompare",

    documentation: "Compares two strings in the current locale.",
    detail:
      "localeCompare(that: string, locales?: string | string[], options?: Intl.CollatorOptions): number",
    insertText: "localeCompare(${1:that}, ${2:locales}, ${3:options})",
  },
  {
    label: "match",

    documentation: "Retrieves the matches when matching a string against a regular expression.",
    detail: "match(regexp: string | RegExp): RegExpMatchArray | null",
    insertText: "match(${1:regexp})",
  },
  {
    label: "matchAll",

    documentation:
      "Returns an iterator of all results matching a string against a regular expression.",
    detail: "matchAll(regexp: string | RegExp): IterableIterator<RegExpMatchArray>",
    insertText: "matchAll(${1:regexp})",
  },
  {
    label: "normalize",

    documentation: "Returns the Unicode Normalization Form of a given string.",
    detail: "normalize(form?: 'NFC' | 'NFD' | 'NFKC' | 'NFKD'): string",
    insertText: "normalize(${1:form})",
  },
  {
    label: "padEnd",

    documentation:
      "Pads the current string with another string (repeated, if needed) so that the resulting string reaches a given length.",
    detail: "padEnd(targetLength: number, padString?: string): string",
    insertText: "padEnd(${1:targetLength}, ${2:padString})",
  },
  {
    label: "padStart",

    documentation:
      "Pads the current string with another string (repeated, if needed) so that the resulting string reaches a given length.",
    detail: "padStart(targetLength: number, padString?: string): string",
    insertText: "padStart(${1:targetLength}, ${2:padString})",
  },
  {
    label: "repeat",

    documentation:
      "Returns a new string which contains the specified number of copies of the string on which it was called, concatenated together.",
    detail: "repeat(count: number): string",
    insertText: "repeat(${1:count})",
  },
  {
    label: "replace",

    documentation:
      "Returns a new string with some or all matches of a pattern replaced by a replacement.",
    detail:
      "replace(searchValue: string | RegExp, replaceValue: string | ((substring: string, ...args: any[]) => string)): string",
    insertText: "replace(${1:searchValue}, ${2:replaceValue})",
  },
  {
    label: "replaceAll",

    documentation: "Returns a new string with all matches of a pattern replaced by a replacement.",
    detail:
      "replaceAll(searchValue: string | RegExp, replaceValue: string | ((substring: string, ...args: any[]) => string)): string",
    insertText: "replaceAll(${1:searchValue}, ${2:replaceValue})",
  },
  {
    label: "search",

    documentation:
      "Executes the search for a match between a regular expression and this String object.",
    detail: "search(regexp: string | RegExp): number",
    insertText: "search(${1:regexp})",
  },
  {
    label: "slice",

    documentation:
      "Extracts a section of a string and returns it as a new string, without modifying the original string.",
    detail: "slice(start?: number, end?: number): string",
    insertText: "slice(${1:start}, ${2:end})",
  },
  {
    label: "split",

    documentation:
      "Splits a String object into an array of strings by separating the string into substrings.",
    detail: "split(separator: string | RegExp, limit?: number): string[]",
    insertText: "split(${1:separator}, ${2:limit})",
  },
  {
    label: "startsWith",

    documentation: "Determines whether a string begins with the characters of a specified string.",
    detail: "startsWith(searchString: string, position?: number): boolean",
    insertText: "startsWith(${1:searchString}, ${2:position})",
  },
  {
    label: "substring",

    documentation:
      "Returns the part of the string between the start and end indexes, or to the end of the string.",
    detail: "substring(start: number, end?: number): string",
    insertText: "substring(${1:start}, ${2:end})",
  },
  {
    label: "toLocaleLowerCase",

    documentation:
      "Returns the calling string value converted to lower case, according to any locale-specific case mappings.",
    detail: "toLocaleLowerCase(locales?: string | string[]): string",
    insertText: "toLocaleLowerCase(${1:locales})",
  },
  {
    label: "toLocaleUpperCase",

    documentation:
      "Returns the calling string value converted to upper case, according to any locale-specific case mappings.",
    detail: "toLocaleUpperCase(locales?: string | string[]): string",
    insertText: "toLocaleUpperCase(${1:locales})",
  },
  {
    label: "toLowerCase",

    documentation: "Returns the calling string value converted to lower case.",
    detail: "toLowerCase(): string",
    insertText: "toLowerCase()",
  },
  {
    label: "toString",

    documentation: "Returns a string representing the specified Number object.",
    detail: "toString(radix?: number): string",
    insertText: "toString(${1:radix})",
  },
  {
    label: "toUpperCase",

    documentation: "Returns the calling string value converted to upper case.",
    detail: "toUpperCase(): string",
    insertText: "toUpperCase()",
  },
  {
    label: "toWellFormed",

    documentation: "Returns a well-formed string created from the given string.",
    detail: "toWellFormed(): string",
    insertText: "toWellFormed()",
  },
  {
    label: "trim",
    documentation: "Removes whitespace from both ends of a string.",
    detail: "trim(): string",
    insertText: "trim()",
  },
  {
    label: "trimEnd",
    documentation: "Removes whitespace from the end of a string.",
    detail: "trimEnd(): string",
    insertText: "trimEnd()",
  },
  {
    label: "trimStart",
    documentation: "Removes whitespace from the beginning of a string.",
    detail: "trimStart(): string",
    insertText: "trimStart()",
  },
  {
    label: "toLocaleString",
    documentation: "Converts a number into a string, using locale-specific formatting.",
    detail:
      "toLocaleString(locales?: string | string[], options?: Intl.NumberFormatOptions): string",
    insertText: "toLocaleString(${1:locales}, ${2:options})",
  },
  {
    label: "Email",
    documentation: "Returns the entry author's email address.",
    detail: "author().Email(): string",
    insertText: "Email()",
    requiresPrefix: "author().",
  },
  {
    label: "DisplayName",
    documentation: "Returns the entry author's display name.",
    detail: "author().DisplayName(): string",
    insertText: "DisplayName()",
    requiresPrefix: "author().",
  },
];
export type JsFunction = {
  label: string;
  documentation: string;
  detail: string;
  insertText: string;
  requiresPrefix?: string;
};
